import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { IMedicineStockBatch } from '../models/medicine.model';

export type MedicineStockBatchUsageForm = FormGroup<{
  medicineStockBatchId: FormControl<string>;
  amount: FormControl<number>;
}>;

export class UseMedicineStockForm extends FormGroup {
  readonly reason = this.get('reason') as FormControl<string>;
  readonly batches = this.get('batches') as FormArray<MedicineStockBatchUsageForm>;

  constructor(stockBatches: IMedicineStockBatch[]) {
    const batches = new FormArray(
      stockBatches.map((batch) => UseMedicineStockForm.createBatchUsageForm(batch)),
      UseMedicineStockForm.requireUsedBatch
    );
    super({
      reason: new FormControl('', { nonNullable: true, validators: Validators.required }),
      batches,
    });
  }

  private static createBatchUsageForm(batch: IMedicineStockBatch): MedicineStockBatchUsageForm {
    return new FormGroup({
      medicineStockBatchId: new FormControl(batch.id, { nonNullable: true }),
      amount: new FormControl(0, {
        nonNullable: true,
        validators: [Validators.min(0), Validators.max(batch.quantity)],
      }),
    });
  }

  private static requireUsedBatch(control: AbstractControl): ValidationErrors | null {
    const hasUsedBatch = control.value.some((batch: { amount: number }) => batch.amount > 0);
    return hasUsedBatch ? null : { required: true };
  }
}
